<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Media from "@components/common/Media.svelte";
	import callQuality from "@core/assets/icons/call-quality.svg?raw";
	import email from "@core/assets/icons/email.svg?raw";
	import fastest from "@core/assets/icons/fastest.svg?raw";
	import flame from "@core/assets/icons/flame.svg";
	import { getCodeOfConductPath } from "@core/schema/paths/getCodeOfConductPath.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getPrivacyPolicyPath } from "@core/schema/paths/getPrivacyPolicyPath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { cartSummaryHeight } from "../../state/cartSummaryHeight.svelte.js";
	import FollowUs from "../sections/FollowUs.svelte";

	const { tenant } = getGlobalTemplateProps();

	const contacts: [label: string, href: string, icon: string][] = [
		["777 717 170", "tel:+420777717170", callQuality],
		["info@zazehnuto.cz", "mailto:info@zazehnuto.cz", email],
	];
</script>

<footer class="mt-24" style:margin-bottom={`${cartSummaryHeight.value}px`}>
	<FollowUs />
	<section class="grid-container bg-nov-light-100">
		<div class="flex flex-col lg:flex-row">
			<div class="flex grow flex-col container-end-6 h-full">
				<a href={getHomepagePath(tenant)} class="flex items-center gap-1 mb-6 lg:mb-0 text-[1.25rem]/6 lg:text-11/12">
					<span class="font-semibold -tracking-[0.005em]">
						<Media alt="🔥" width={24} height={24} source={{ src: flame, type: "image/svg+xml" }} class="size-[1em]" />
					</span>
					<span class="text-nov-dark-900 -tracking-[0.005em] font-bold">Zažehnuto.cz</span>
				</a>
				<div class="grow"></div>
				<div>
					<div class="h4 lg:mb-6 !text-nov-red-300">Menu</div>

					<ul class="flex gap-1 lg:gap-3 flex-col mb-6 lg:mb-0">
						<li>
							<a class="underline text-body17" href={getPrivacyPolicyPath(tenant)}>Zásady ochrany osobních údajů</a>
						</li>
						<li>
							<a class="underline text-body17" href={getCodeOfConductPath(tenant)}>Etický kodex</a>
						</li>
						<li>
							<a class="underline text-body17" href="/ObchodniPodminky.pdf" target="_blank">Obchodní podmínky</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="flex grow flex-col">
				<div class="h4 lg:mb-5.5 !text-nov-red-300">Máte dotaz?</div>
				<p class="text-nov-dark-800 mb-6">Napište na e-mail, nebo se s námi spojte telefonicky.</p>
				<ul class="flex flex-col gap-4 mb-16">
					{#each contacts as [label, href, icon] (label + href + icon)}
						<li class="flex gap-6 items-center">
							<div class="size-18 bg-white flex items-center justify-center rounded-full">
								<Icon {icon} class="text-nov-red-300" />
							</div>
							<a {href} class="text-nov-dark-900 leading-none xl:text-12 md:text-10 sm:text-8 text-6 font-bold">
								{label}
							</a>
						</li>
					{/each}
				</ul>
				<div class="h4 mb-5.5 !text-nov-red-300">Údaje o nás</div>
				<div class="flex flex-col md:flex-row gap-12 text-nov-dark-800">
					<div>
						<p class="mb-6">
							<strong>Novakon TRADE s.r.o.</strong><br />
							Boženy Němcové 126<br />
							330 27 Vejprnice
						</p>
						<p>
							<strong>Identifikační čísla</strong><br />
							IČ: 26402157<br />
							DIČ: CZ26402157
						</p>
					</div>
					<div class="max-w-76">
						<p>
							<Formatted
								text="Společnost je zapsána v obchodním rejstříku vedeném Krajským soudem v Plzni, oddíl C, vložka 17931."
							/>
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
	<div class="bg-black grid-container">
		<div class="flex flex-col md:flex-row py-4 text-nov-light-300 text-body17 gap-y-3 justify-evenly items-center">
			<span>&copy; 2025 Novakon s. r. o.</span>
			<div class="grow"></div>
			<span class="flex items-center gap-2">
				<span>Ukováno ve</span>
				<a href="https://fastest.cz/" target="_blank" aria-label="Fastest">
					<Icon icon={fastest} class="h-6 -translate-y-[0.125em]" />
				</a>
			</span>
		</div>
	</div>
</footer>
